import { useEffect } from "react";
import { version } from "../../../package.json";
import { useLocation } from "react-router-dom";
import useOnlineStatus from "~hooks/useOnlineStatus";
import { clearCache } from "~services/GlobalServices";


const useNavigationUrl = () => {
  const { pathname } = useLocation();
  const isOnline = useOnlineStatus();

  useEffect(() => {
    const saveUrlLocalStorage = (url) => {
      const history = JSON.parse(sessionStorage.getItem("rotas")) || [];
      localStorage.removeItem("tabela-preco-alteracoes");
      if (history.length === 0 || history[history.length - 1] !== url) {
        history.push(url);
        sessionStorage.setItem("rotas", JSON.stringify(history));
      }
    };
    saveUrlLocalStorage(pathname);
    const clearMM = () => {
      const history = JSON.parse(sessionStorage.getItem("rotas")) || [];
      const lastUrl = history[history.length - 2];
      const getLastIdFromUrl = (url) => {
        if (!url) return null;
        const match = url.match(/\/pesquisa-de-preco\/(\d+)/);
        return match ? match[1] : null;
      };
      const idAtual = getLastIdFromUrl(pathname);
      const idAntigo = getLastIdFromUrl(lastUrl);

      if (idAntigo && idAtual !== idAntigo) {
        if (!pathname.startsWith("/pesquisa-de-preco")) {
          clearCache(idAntigo);
        } else {
          clearCache(idAntigo);
        }
      }
    };
    if (isOnline) {
      clearMM();
    }

    if (pathname !== "/tabela-preco") {
      sessionStorage.removeItem("indexs");
    }
    const removeTabelaPrecoAlteracoes = () => {
      if (!pathname.includes("tabela-preco")) {
        localStorage.removeItem("tabela-preco-alteracoes");
        localStorage.removeItem("tabela-preco-alteracoes-checkbox");
      }
    };

    removeTabelaPrecoAlteracoes();
    window.addEventListener("beforeunload", removeTabelaPrecoAlteracoes);
    return () => {
      window.removeEventListener("beforeunload", removeTabelaPrecoAlteracoes);
    };
  }, [pathname]);

  useEffect(() => {
    const savedVersion = localStorage.getItem("app_version");
    if (savedVersion !== version) {
      localStorage.setItem("app_version", version);

      if ("caches" in window) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
          });
        });
      }
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((registration) => registration.unregister());
        });
      }
      window.location.reload();
    }
  }, [pathname]);



  return {  };
};

export default useNavigationUrl;
